// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__MapiY","sendOtp":"AuthorizeToLogin_sendOtp__1Sdr6"};